/**
 * Created by rorschach on 2018/1/30.
 */
import React from "react";
import Toast from "antd-mobile/lib/toast";
import "antd-mobile/lib/toast/style";
import { noop } from "lodash";

// const PREFIX = "xyui-toast";
const MASK_DEFAULT = false;
const DEFAULT_TOAST_OPTIONS = {
  content: "",
  duration: 2, // 单位是秒
  mask: false,
  onClose: noop
};
const DEFAULT_LOADING_TOAST_OPTIONS = {
  content: "",
  duration: 100, // 单位是秒, loading类型设置长一点100秒, 后面需要手动关闭
  mask: true,
  onClose: noop
};

class BxToast extends React.Component {
  render() {
    const { mask = MASK_DEFAULT, ...others } = this.props;

    const newProps = {
      mask,
      ...others
    };
    return <Toast ref="instance" {...newProps} />;
  }
}

function createOptions(options, actionName) {
  if (typeof options === "string") {
    options = {
      content: options
    };
  }
  options = {
    ...(actionName === "loading"
      ? DEFAULT_LOADING_TOAST_OPTIONS
      : DEFAULT_TOAST_OPTIONS),
    ...options
  };
  return options;
}

function showToast(options, actionName = "info") {
  const { content, duration, onClose, mask } = createOptions(
    options,
    actionName
  );
  return new Promise((resolve, reject) => {
    const _onClose = () => {
      resolve();
      onClose();
    };
    return Toast[actionName](content, duration, _onClose, mask);
  });
}

BxToast.show = function show(options) {
  return showToast(options, "show");
};
BxToast.hide = Toast.hide;

BxToast.info = function info(options) {
  return showToast(options, "info");
};
BxToast.success = function success(options) {
  return showToast(options, "success");
};
BxToast.fail = function fail(options) {
  return showToast(options, "fail");
};
BxToast.offline = function offline(options) {
  return showToast(options, "offline");
};
BxToast.loading = function loading(options) {
  return showToast(options, "loading");
};

export default BxToast;



// WEBPACK FOOTER //
// ./src/xyui/src/toast/index.js